// Reagenda con aviso de solape (28/9/2026: «Girona kebab» se movió a las 14:15 encima de
// «Asador Victorio» y nada avisó). El backend (PUT /ventas/demos) responde 409
// {error:"slot_taken", conflicts} si la hora nueva pisa algo de la agenda del closer; aquí
// se enseña qué pisa y, si el closer lo quiere igualmente, se reintenta con force_overlap.
// Lo usan los tres caminos de reagenda (arrastrar en el calendario, modal y ficha del lead).
import { updateDemo } from "../../api/demosApi";

export const RESCHEDULE_CANCELLED = Symbol("reschedule_cancelled");

function hhmm(iso, lang) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString(lang === "en" ? "en-GB" : "es-ES", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Madrid" });
}

export function buildOverlapConfirm(conflicts, t, lang) {
  const lines = [t("translation:demos.overlap.title")];
  for (const c of conflicts || []) {
    const from = hhmm(c.start, lang);
    const to = c.end ? hhmm(c.end, lang) : "";
    lines.push(`- ${to ? `${from}–${to}` : from} ${c.title || ""}`.trimEnd());
  }
  lines.push("", t("translation:demos.overlap.question"));
  return lines.join("\n");
}

export function isSlotTakenError(e) {
  return e?.response?.status === 409 && e?.response?.data?.error === "slot_taken";
}

// Devuelve la respuesta del backend, o RESCHEDULE_CANCELLED si el closer no quiso solapar.
export async function rescheduleDemo(payload, { t, lang, confirm = (m) => window.confirm(m) }) {
  try {
    return await updateDemo(payload);
  } catch (e) {
    if (!isSlotTakenError(e)) throw e;
    const conflicts = e.response.data.conflicts || [];
    if (!confirm(buildOverlapConfirm(conflicts, t, lang))) return RESCHEDULE_CANCELLED;
    return updateDemo({ ...payload, force_overlap: true });
  }
}
